export default __webpack_public_path__ + "static/media/lock.df66741d.svg";